import middleware from "../../../shared/middleware";

const { fetchVideoUrl } = middleware;

export const shakaHandleLicenseRequest = async (
  request,
  shakaIsPlaybackStarted,
  shakaKeyRotationToken,
  shakaKeyRotationExpiryTimeout,
  contentType,
  appProvider,
  currentContentId,
  assetId,
  parentalPin
) => {
  // If playback is in session, handle key rotation
  if (shakaIsPlaybackStarted.current) {
    if (shakaKeyRotationToken.current) {
      request.headers.Authorization = shakaKeyRotationToken.current;
    } else {
      let response;
      try {
        response = await fetchVideoUrl(appProvider, contentType, currentContentId, assetId, parentalPin, true);
      } catch (err) {
        console.error("Failed to get auth token, error = ", err);
      }
      if (response?.token) {
        shakaKeyRotationToken.current = response.token;
        request.headers.Authorization = response.token;
        shakaKeyRotationExpiryTimeout.current = setTimeout(() => {
          // Use the same token for subsequent license requests within the next 30 seconds
          shakaKeyRotationToken.current = null;
        }, 30000);
      }
    }
  }
  return Promise.resolve(request);
};

export const shakaHandleManifestResponse = async (response, isSafari, isFast, cdnUrl) => {
  if (!isSafari && isFast) {
    return Promise.resolve(response);
  }

  cdnUrl.current = response.uri;
  return Promise.resolve(response);
};
